// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ../~/minimal.css/minimal.css
// module id = 645
// module chunks = 0